// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__p0p-n","header":"PatientBlock_header__FTIyD","label":"PatientBlock_label__gDaaf","option":"PatientBlock_option__3e99x"};